import { render, staticRenderFns } from "./AllNotes.vue?vue&type=template&id=45e6b7be"
import script from "./AllNotes.vue?vue&type=script&lang=js"
export * from "./AllNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports